import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';

const PORTAL_ID = import.meta.env.VITE_REACT_APP_HUBSPOT_PORTAL_ID || '';
const FORM_ID = import.meta.env.VITE_REACT_APP_HUBSPOT_B2B_FORM_ID || '';
const FORM_TG_ID = import.meta.env.VITE_REACT_APP_HUBSPOT_B2B_TG_FORM_ID || '';
const formDivId = 'hubspot-form-wrapper';
const identifierField = 'b2b_request__userid_email_tg_id';

interface B2BFormProps {
  formSubmitted: () => void;
  userId: string | number;
  isTG?: boolean;
}

const B2BForm: FC<B2BFormProps> = ({ formSubmitted, userId, isTG = false }) => {
  const { t } = useTranslation();

  const { loaded, error, formCreated } = useHubspotForm({
    portalId: PORTAL_ID,
    formId: isTG ? FORM_TG_ID : FORM_ID,
    target: `#${formDivId}`,
    onFormSubmitted: () => formSubmitted(),
    onFormReady: (form) => {
      const userInput = form.querySelector(`input[name="${identifierField}"]`);
      if (userInput) {
        userInput.value = userId;
      }
    },
  });

  return <div id={formDivId} />;
};

export default B2BForm;
